import React from "react";
import logo from "./dark.png";

interface Props {
  width?: number | string;
}
export function DWSLogotypeDark({ width = "100%" }: Props) {
  return <img src={logo} alt="digital wholesale solutions" width={width} />;
}
